module.exports = __webpack_public_path__ + "media/images/icons/answer-f2547efa47d429ed9787596f1a81f0b7.svg";